export default __webpack_public_path__ + "static/4i-85b2f9813ec12e45cad12b26344db0eb.woff";